global.Numeral = require('numeral');
